import React, { useState } from "react";

import { useTranslation } from "react-i18next";

const KERC_ISSUE_REPORTS = [
  {
    title: "2023 동해(강원) 연속지진 보고서",
    fileSizeMB: 3.3,
    url: "https://library.kigam.re.kr/report/2023/2023동해(강원)연속지진보고서.pdf",
    image: "annualreports/표지_2023 동해(강원) 연속지진 보고서.png",
  },
  {
    title: "2023 튀르키예 대지진으로 살펴본 KIGAM 국외지진 연구현황",
    fileSizeMB: 15.5,
    url: "https://library.kigam.re.kr/report/2023/2023튀르키예대지진으로살펴본KIGAM국외지진연구현황.pdf",
    image: "annualreports/표지_KIGAM 국외지진 연구현황.png",
  },
  {
    title: "2022 괴산지진 보고서",
    fileSizeMB: 5.3,
    url: "https://library.kigam.re.kr/report/2022/2022괴산지진보고서.pdf",
    image: "annualreports/표지_2022 괴산지진 보고서.png",
  },
  {
    title: "2020 해남지진 TF 보고서",
    fileSizeMB: 17.4,
    url: "https://library.kigam.re.kr/report/2020/2020해남지진TF보고서.pdf",
    image: "annualreports/표지_2020 해남지진TF보고서.png",
  },
  {
    title: "일반인을 위한 한반도 동남권 지진",
    fileSizeMB: 18.8,
    url: "https://library.kigam.re.kr/report/2018/일반인을위한한반도동남권지진.pdf",
    image: "annualreports/표지_일반인을 위한 한반도 동남권 지진.png",
  },
];


const KERC_SEISMIC_ACTIVITY_ATLAS_2024_V1 = [
  {
    // title: "Volume 1, Part 1",
    part: 1,
    fileSizeMB: 291,
    url: "https://library.kigam.re.kr/report/2024/2024한반도지진활동도총서(상1권).pdf",
    image: "annualreports/kerc_seismic_activity_atlas_1_1.png",
  },
  {
    // title: "Volume 1, Part 2",
    part: 2,
    fileSizeMB: 337,
    url: "https://library.kigam.re.kr/report/2024/2024한반도지진활동도총서(상2권).pdf",
    image: "annualreports/kerc_seismic_activity_atlas_1_2.png",
  },
  {
    // title: "Volume 1, Part 3",
    part: 3,
    fileSizeMB: 526,
    url: "https://library.kigam.re.kr/report/2024/2024한반도지진활동도총서(상3권).pdf",
    image: "annualreports/kerc_seismic_activity_atlas_1_3.png",
  }, 
];

const KERC_SEISMIC_ACTIVITY_ATLAS_2024_V2 = [
  {
    // title: "Volume 2, Part 1",
    part: 1,
    fileSizeMB: 326,
    url: "https://library.kigam.re.kr/report/2024/2024한반도지진활동도총서(하1권).pdf",
    image: "annualreports/kerc_seismic_activity_atlas_2_1.png",
  },
  {
    // title: "Volume 2, Part 2",
    part: 2,
    fileSizeMB: 364,
    url: "https://library.kigam.re.kr/report/2024/2024한반도지진활동도총서(하2권).pdf",
    image: "annualreports/kerc_seismic_activity_atlas_2_2.png",
  },
  {
    // title: "Volume 2, Part 3",
    part: 3,
    fileSizeMB: 428,
    url: "https://library.kigam.re.kr/report/2024/2024한반도지진활동도총서(하3권).pdf",
    image: "annualreports/kerc_seismic_activity_atlas_2_3.png",
  },
  
];


const KERC_ANNUAL_REPORTS = [
  {
    // title: "2019 지진학술연보",
    year: 2019,
    fileSizeMB: 109,
    url: "https://library.kigam.re.kr/report/2019/2019학술지진연보.pdf",
    image: "annualreports/kerc_annual_report_2019.jpg",
    imageDesc: "2019년 정밀분석 진앙 분포",
    isAnnualReport: true,
  },
  {
    // title: "2020 지진학술연보",
    year: 2020,
    fileSizeMB: 55,
    url: "https://library.kigam.re.kr/report/2021/2020학술지진연보.pdf",
    image: "annualreports/kerc_annual_report_2020.jpg",
    imageDesc: "2020년 정밀분석 진앙 분포",
    isAnnualReport: true,
  },
  {
    // title: "2021 지진학술연보",
    year: 2021,
    fileSizeMB: 226,
    url: "https://library.kigam.re.kr/report/2022/2021학술지진연보.pdf",
    image: "annualreports/kerc_annual_report_2021.png",
    imageDesc: "2021년 정밀분석 진앙 분포",
    isAnnualReport: true,
  },
  {
    // title: "2022 지진학술연보",
    year: 2022,
    fileSizeMB: 104,
    url: "https://library.kigam.re.kr/report/2023/2022학술지진연보.pdf",
    image: "annualreports/kerc_annual_report_2022.png",
    imageDesc: "2022년 정밀분석 진앙 분포",
    isAnnualReport: true,
  },
  {
    // title: "2023 지진학술연보",
    year: 2023,
    fileSizeMB: 57,
    url: "https://library.kigam.re.kr/report/2024/2023학술지진연보.pdf",
    image: "annualreports/kerc_annual_report_2023.png",
    imageDesc: "2023년 정밀분석 진앙 분포",
    isAnnualReport: true,
  },
];

export const AnnualReports = () => {
  // const [selectedReport, setSelectedReport] = useState(null);
  const [selectedReport, setSelectedReport] = useState(
    KERC_ISSUE_REPORTS.at(0)
  );

  const { t, i18n } = useTranslation();
  console.log("AnnualReports: i18n.language = ", i18n.language);

  const downloadReport = async () => {
    if (!selectedReport) {
      window.alert(t("page.annual-report.selectReportWarning"));
      return;
    }

    if (
      !window.confirm(
        t("page.annual-report.largeDownloadWarning", {
          fileSizeInMB: selectedReport.fileSizeMB,
        })
      )
    ) {
      return;
    }

    window.open(selectedReport.url, "_blank");
  };

  return (
    <div className="container">
      <div className="sub-container">
        <div style={{ fontSize: "15px", marginBottom: "5px" }}>
          &nbsp;&nbsp;<i className="ion ion-md-help-circle-outline"></i>
          {t("page.annual-report.desc")}
        </div>
        <div className="overflow-auto">
          <table className="datatable mb20">
            <colgroup className="">
              <col style={{ width: "20%" }} />
              <col style={{ width: "80%" }} />
            </colgroup>
            <tbody>
              <tr>
                <th className="first">
                  {t("page.annual-report.issue-report")}
                </th>
                <td className="first clearfix">
                  <div className="left">
                    {KERC_ISSUE_REPORTS.map((report) => (
                      <div key={report.title}>
                        <label
                          className="datatable_select_radio"
                          htmlFor={`report.${report.title}`}
                        >
                          <input
                            type="radio"
                            id={`report.${report.title}`}
                            name="report.catalog"
                            className="with-gap"
                            checked={selectedReport === report}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedReport(report);
                              }
                            }}
                          />
                          <span>{report.title}</span>
                        </label>
                      </div>
                    ))}
                  </div>
                </td>
              </tr>
              <tr>
                <th>{t("page.annual-report.seismic-activity-atlas-2024")}</th>
                <td className="clearfix">
                  <div className="left">
                    <div>
                      {KERC_SEISMIC_ACTIVITY_ATLAS_2024_V1.map((report) => (
                        <label
                          key={report.part}
                          className="datatable_select_radio"
                          htmlFor={`report.activity.1.${report.part}`}
                        >
                          <input
                            type="radio"
                            id={`report.activity.1.${report.part}`}
                            name="report.catalog"
                            className="with-gap"
                            checked={selectedReport === report}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedReport(report);
                              }
                            }}
                          />
                          <span>{i18n.language === "en" ? `Volume 1, Part ${report.part}`: `상${report.part}권`}</span>
                        </label>
                      ))}
                    </div>
                    <div>
                      {KERC_SEISMIC_ACTIVITY_ATLAS_2024_V2.map((report) => (
                        <label
                          key={report.part}
                          className="datatable_select_radio"
                          htmlFor={`report.activity.2.${report.part}`}
                        >
                          <input
                            type="radio"
                            id={`report.activity.2.${report.part}`}
                            name="report.catalog"
                            className="with-gap"
                            checked={selectedReport === report}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedReport(report);
                              }
                            }}
                          />
                          <span>{i18n.language === "en" ? `Volume 2, Part ${report.part}`: `하${report.part}권`}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{t("page.annual-report.annual-report")}</th>
                <td className="clearfix">
                  <div className="left">
                    {KERC_ANNUAL_REPORTS.map((report) => (
                      <label
                        key={report.year}
                        className="datatable_select_radio"
                        htmlFor={`report.annual.${report.year}`}
                      >
                        <input
                          type="radio"
                          id={`report.annual.${report.year}`}
                          name="report.catalog"
                          className="with-gap"
                          checked={selectedReport === report}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedReport(report);
                            }
                          }}
                        />
                        <span>
                          {t("form.duration.year", { year: report.year })}
                          &nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                      </label>
                    ))}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="center-align row">
            <button
              type="button"
              className="waves-effect waves-light button-lg btn-block"
              onClick={() => downloadReport()}
            >
              {t("w.download")}
            </button>
          </div>
          {selectedReport && (
            <div className="center-align row" style={{ marginTop: 15 }}>
              <img
                src={`https://kr.object.gov-ncloudstorage.com/kerc-kquake-public/web/${selectedReport.image}`}
                alt="발간물 대표 이미지"
                style={{ maxWidth: 625, width: "100%" }}
              />
              <br />
              <br />
              {selectedReport.isAnnualReport && (
                <span>
                  &#60;
                  {t("page.annual-report.imageCaption", {
                    year: selectedReport.year,
                  })}
                  &#62;
                </span>
              )}
            </div>
          )}
        </div>
      </div>
      {/* <LoadingScreen screen={isLoading} /> */}
    </div>
  );
};
